import env from '../env';

export { trimLeadingSlashes, trimSlashes, trimTrailingSlashes } from './trimSlashes';

/**
 * Join two or more paths together, while removing excessive slashes.
 */
export const join = (...paths: string[]): string =>
  '/' +
  paths
    .join('/')
    .replace(/\/\.\//, '/') // Replace dots like /./ with a single slash
    .replace(/\/{2,}/g, '/') // Replace repeated slashes with a single slash
    .replace(/^\//g, ''); // Replace leading slashes

export const removeHostedBasePath = (path: string) => path.replace(/^\/pr-\d+\/?/, '/');

/**
 * Removes query string and hash from path, never return empty string. See specs for more
 * details.
 */
export const sanitizePath = (path: string): string => {
  // `/[?#].*$/` retried the scan at every "?" or "#" (Sonar S8786); cut at the first one instead.
  const suffixStart = path.search(/[?#]/);
  return (suffixStart === -1 ? path : path.slice(0, suffixStart)) || '/';
};

export const toURL = (path: string) => (env('HOST') ? new URL(path, env('HOST')).href : path);

export const removeQueryParam = (paramName: string) => {
  if (typeof window === 'undefined') return;

  const url = new URL(window.location.href);

  url.searchParams.delete(paramName);

  window.history.replaceState({}, '', url.toString());
};
